export interface IArticleChild {
    children: IArticleChild[];
    type?: 'root' | 'element' | 'text';
    value?: string;
    tag?: string;
    props?: { [path in string]: string };
}

export interface IArticle {
    title: string;
    img: string;
    date: string; // 2022-05-08
    tag: string; // how-to
    description?: string;
    readingTime?: number; // whole minutes, computed from the body at sync time
    path?: string;
    body?: {
        children: IArticleChild[];
    };
}

// Fields a post card (components/Article.vue) needs. List/hub pages must
// `.select(...BLOG_CARD_FIELDS)` rather than fetching whole posts: the query
// result is serialised into the page's inline __NUXT_DATA__ payload, and full
// post bodies made /blog, /casestudies and every category page ~10MB.
export const BLOG_CARD_FIELDS = ['path', 'title', 'date', 'img', 'tag', 'description', 'readingTime'] as const;

export function localDate(date: Date | string | number) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('en', options as any);
}

export function html(root: IArticle, obj?: IArticleChild, length = 150) {
    let str = obj ? '' : root.description || '';
    if (obj?.type === 'text' && obj.value !== root.title && obj.value !== localDate(root.date)) {
        // console.log('obj', obj);
        str += obj.value;
    }
    for (const child of obj?.children || []) {
        str += html(root, child, 99999);
    }
    if (str.length > length) {
        const l = str.lastIndexOf(' ', length);
        return str.substring(0, l) + '...';
    } else {
        return str;
    }
}

const WORDS_PER_MINUTE = 230;

// Reading time in whole minutes (minimum 1) from a post's Markdown body.
// Counts prose only: fenced/inline code, tables, HTML, images and the bare URL
// part of links are dropped so they don't inflate (or deflate) the estimate.
export function readingTimeMinutes(markdown: string): number {
    const text = markdown
        .replace(/```[\s\S]*?```/g, ' ')
        .replace(/~~~[\s\S]*?~~~/g, ' ')
        .replace(/^\s*\|.*$/gm, ' ')
        .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
        .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
        .replace(/<[^>]+>/g, ' ')
        .replace(/`[^`]*`/g, ' ')
        .replace(/[#>*_~-]+/g, ' ');
    const words = text.split(/\s+/).filter((w) => /[\p{L}\p{N}]/u.test(w)).length;
    return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE));
}
